function initForms() {
	// When clicking a form submit button :
	$('.wpcf7-submit').on('click', function () {

		var $formBlock = $( this ).closest( '.form-block' );

		$formBlock.addClass('loading');
	});

	// When the form validation fails or the mail fails to be sent :
	$('.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed', function () {

		var $formBlock = $( this ).closest( '.form-block' );
		$formBlock.removeClass( 'loading' );
		setTimeout( function() {
			matchHeightReset();
		}, 100 );
	});

	// When the mail is successfully sent
	$('.wpcf7').on('wpcf7mailsent', function () {
		var $formBlock = $( this ).closest( '.form-block' );
		var $formInput = $( this ).find( '.form__container' );
		var $formFile  = $( this ).find( '.form__label--file' );
		var $formReset = $( this ).find( 'input#resetForm' );

		$formBlock.removeClass( 'loading' );
		$formBlock.addClass( 'success' );

		setTimeout( function() {
			$formBlock.removeClass( 'success' );
			$formReset.click();
			$formInput.removeClass( 'filled' );
			$formFile.each( function() {
				label = "";
				label = $( this ).data( 'label' );
				$( this ).html( label );
			});

		}, 2000 );
	});

	// Managing form inputs and labels focus and filled states :
	$('.form__field input, .form__field--textarea textarea, .form__field--select select').each(function() {
		$(this).on('focus', function(){

			$(this).closest('.form__container').addClass('active');
		}).on('blur', function(){

			$(this).closest('.form__container').removeClass('active');

			if( $(this).val() === "" ) {
				$(this).closest('.form__container').removeClass('filled');
			} else {
				$(this).closest('.form__container').addClass('filled');
			}
		});
	});

	// Managing file inputs
	$('.form__field--file').each( function() {
		var input	 = $( this ).find( 'input' ),
			label	 = $( this ).closest('.form__container').find( 'label' ),
			labelVal = label.html();

		input.on( 'change', function( e ) {

			var fileName = e.target.value.split( '\\' ).pop();

			if ( fileName ) {
				label.html( fileName );
			} else {
				label.html( labelVal );
			}
		});

		// Firefox bug fix
		input
			.on( 'focus', function() { input.addClass( 'has-focus' ); })
			.on( 'blur',  function() { input.removeClass( 'has-focus' ); });
	});

}












